import type { Requests } from "../common/request.common";
import type { AgentPaymentResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const agentPayment = {
    record(data: typeof Requests.AgentPayment.Record.Input) {
        return post<typeof data, AgentPaymentResponseTypes.Record>(`/agent-payment/record`, data);
    },
    obtain(id: string) {
        return get<AgentPaymentResponseTypes.Obtain>(`/agent-payment/obtain/${id}`);
    },
    createPayment(
        customerInvoiceId: string,
        data: typeof Requests.AgentPayment.CreatePayment.Input,
    ) {
        return post<typeof data>(`/agent-payment/create-payment/${customerInvoiceId}`, data);
    },
};
